module.exports = __webpack_public_path__ + "assets/img/3.78254f3f.png";